import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function GetExportInteractionsNotification(
    projectId,
    notificationId,
    type = '',
    page = 1,
    search = ''
) {
    const user = store?.getState()?.user
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${
                process.env.REACT_APP_MYXP_API_NOTIFICATION
            }/xpmgr/notifications/interactions/${projectId}/${notificationId}/export?sortOrder=desc${
                type ? `&type=${type}` : ''
            }`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.blob();
    }
}
